import { useMetaTags } from 'src/hooks/use-meta-tags';

type Props = {
  metaTags: Record<string, unknown>;
  routeId?: string;
  locationKey?: string;
};

const MetaTags = (props: Props) => {
  const { routeId, locationKey, metaTags } = props;

  useMetaTags({ routeId, locationKey, metaTags });

  return null;
};

export default MetaTags;
